import { Footer } from "./components/layout/Footer";
import { Navbar } from "./components/layout/Navbar";
import { AgentesSection } from "./components/sections/AgentesSection";
import { CtaSection } from "./components/sections/CtaSection";
import { FeaturesSection } from "./components/sections/FeaturesSection";
import { KelaEnAccionSection } from "./components/sections/KelaEnAccionSection";
import { HeroSection } from "./components/sections/HeroSection";

function App() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <HeroSection />
        <AgentesSection />
        <FeaturesSection />
        <KelaEnAccionSection />
        <CtaSection />
      </main>
      <Footer />
    </div>
  );
}

export default App;
